import React from 'react';
import { Badge, Button } from '@tracekit/core';
import { Rss } from 'lucide-react';
import { RSSFeedSelector } from './RSSFeedSelector';
import { AlertKeywordSettingsSection } from '../AlertKeywordSettingsSection';
import { RSS_FEED_REGISTRY } from '../../services/rssFeedRegistry';

interface IndustryNewsAlertSettingsPanelProps {
  projectId: string;
  selectedFeedIds: string[];
  onSelectedFeedIdsChange: (feedIds: string[]) => void;
  selectedKeywords: string[];
  onSelectedKeywordsChange: (keywords: string[]) => void;
  similarityThreshold: number;
  onSimilarityThresholdChange: (threshold: number) => void;
  onSave: () => void;
}

export function IndustryNewsAlertSettingsPanel({
  projectId,
  selectedFeedIds,
  onSelectedFeedIdsChange,
  selectedKeywords,
  onSelectedKeywordsChange,
  similarityThreshold,
  onSimilarityThresholdChange,
  onSave,
}: IndustryNewsAlertSettingsPanelProps) {
  return (
    <div className="space-y-5">
      <div>
        <div className="mb-3 flex items-center gap-2">
          <Rss className="h-4 w-4 text-orange-600" />
          <label className="block text-sm font-medium">RSS Feed Sources</label>
          <Badge variant="primary" className="text-xs">
            {selectedFeedIds.length} of {RSS_FEED_REGISTRY.length} selected
          </Badge>
        </div>
        <RSSFeedSelector
          selectedFeedIds={selectedFeedIds}
          onSelectionChange={onSelectedFeedIdsChange}
        />
      </div>

      <AlertKeywordSettingsSection
        projectId={projectId}
        selectedKeywords={selectedKeywords}
        onSelectedKeywordsChange={onSelectedKeywordsChange}
        labelClassName="block text-sm font-medium mb-2"
      />

      <div>
        <label className="mb-2 block text-sm font-medium">
          Relevance Threshold ({Math.round(similarityThreshold * 100)}%)
        </label>
        <input
          type="range"
          min={0}
          max={100}
          step={5}
          value={Math.round(similarityThreshold * 100)}
          onChange={(event) =>
            onSimilarityThresholdChange(Number(event.target.value) / 100)
          }
          className="w-full"
        />
      </div>

      <div className="flex justify-end border-t border-gray-100 pt-3 dark:border-slate-700">
        <Button variant="primary" size="sm" onClick={onSave}>
          Save Settings
        </Button>
      </div>
    </div>
  );
}
